module.exports = __webpack_public_path__ + "img/un.bdaf37f9.svg";